module.exports = __webpack_public_path__ + "img/3.6645eb76.jpg";